import { debug } from "tone";
import Entity from "/src/js/engine/entity";
import Hitbox from "/src/js/engine/hitbox";
import CtxTexture from "/src/js/engine/2d/ctxTexture";
import textureURL from "url:/src/img/bullet.png";
import Explosion from "../explosion";

export default class BatteryNote extends Entity{
    constructor({engine, note}){
        super({engine,type:"note"});
        this.note = note;
        this.instrument="battery";
        this.speed = 700;
        this.startPosition = {
            x: this.engine.width + note.time * this.speed,
            y: (this.note.midi/128) * this.engine.height  + Math.sin(this.note.time * Math.PI * 0.7) * 300 + 100,
        };
        this.position = {x:this.startPosition.x,y:this.startPosition.y};
        this.playing = false;
        this.timer = 0;
        this.hitbox = new Hitbox({...this.position, w:30, h:30});
        this.texture = new CtxTexture(textureURL);
    }

    update(){
        const s = this.engine.scaleFactor;
        this.timer += this.engine.time.delta;
        this.playing = this.timer >= this.note.time && this.timer <= this.note.time + this.note.duration;
        this.started = this.timer >= this.note.time && this.timer <= this.note.time + 0.1;
        this.position.x = this.engine.width + this.note.time * this.speed  * s - this.timer * this.speed * s;
    }

    render(ctx){
        const s = this.engine.scaleFactor;

        const w = (20 + 50 * this.note.duration) * s;

        if(this.position.x > this.engine.width || this.position.x < -w) return;

        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        if(this.texture.ready) this.texture.draw(ctx, w);
        ctx.restore();

        this.hitbox.set({...this.position, w: w * .5, h:w * .5});
    }

    hit(){
        new Explosion({engine: this.engine, position: this.position, size: 300});
        this.engine.destroyEntity(this);
    }

    kill(){
        const s = this.engine.scaleFactor;
        let w = (this.note.duration * this.speed - 5) * s;
        if(this.position.x < this.engine.width && this.position.x > -w){
            new Explosion({engine: this.engine, position: this.position, size: 300});
        }   
        this.engine.destroyEntity(this);
    }
}